module.exports = __webpack_public_path__ + "img/music-recommendation-logo.f6723c95.png";